export default "__VITE_ASSET__DGI9OSyD__"